<template>
    <div class="chart">
        <el-row style="margin-left:20px;margin-bottom: 10px">
            <el-col>
                <div class="title-txt" style="margin-top: 10px"><strong style="font-size: 15px;">近24小时消息发送概况</strong>
                </div>
            </el-col>
        </el-row>
        <el-row :gutter="20" style="padding-left: 20px;padding-right: 20px;">
            <el-col :span="6">
                <el-card>
                    <div class="img-title clearfix" line-height="100%">
                        <img align="left" :src="require('@/assets/img/qw.png')" alt="" style="padding-right: 10px;"
                             width="60px" class="img">
                        <div class="title-txt"><strong style="font-size: 15px;">企微消息</strong></div>
                        <div style="margin-top: 5px">
                            <el-tooltip class="item" effect="dark" content="发送成功/发送总量" placement="bottom-end">
                                <span style="color: green">{{this.sucQwCount}}</span>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="发送成功/发送总量" placement="bottom-end">
                                <span> / {{this.qwCount}}</span>
                            </el-tooltip>
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="6">
                <el-card>
                    <div class="img-title clearfix" line-height="100%">
                        <img align="left" :src="require('@/assets/img/sms.png')" alt="" style="padding-right: 10px;"
                             width="60px" class="img">
                        <div class="title-txt"><strong style="font-size: 15px;">短信</strong></div>
                        <div style="margin-top: 5px">
                            <el-tooltip class="item" effect="dark" content="发送成功/发送总量" placement="bottom-end">
                                <span style="color: green">{{this.sucSmsCount}}</span>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="发送成功/发送总量" placement="bottom-end">
                                <span> / {{this.smsCount}}</span>
                            </el-tooltip>
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="6">
                <el-card>
                    <div class="img-title clearfix" line-height="100%">
                        <img align="left" :src="require('@/assets/img/mail.png')" alt="" style="padding-right: 10px;"
                             width="60px" class="img">
                        <div class="title-txt"><strong style="font-size: 15px;">邮件</strong></div>
                        <div style="margin-top: 5px">
                            <el-tooltip class="item" effect="dark" content="发送成功/发送总量" placement="bottom-end">
                                <span style="color: green">{{this.sucMailCount}}</span>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="发送成功/发送总量" placement="bottom-end">
                                <span> / {{this.mailCount}}</span>
                            </el-tooltip>
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="6">
                <el-card>
                    <div class="img-title clearfix" line-height="100%">
                        <img align="left" :src="require('@/assets/img/business.png')" alt=""
                             style="padding-right: 10px;"
                             width="60px" class="img">
                        <div class="title-txt"><strong style="font-size: 15px;">业务消息</strong></div>
                        <div style="margin-top: 5px">
                            <el-tooltip class="item" effect="dark" content="已读数量/消息总量" placement="bottom-end">
                                <span style="color: green">{{this.readBusinessCount}}</span>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="已读数量/消息总量" placement="bottom-end">
                                <span> / {{this.businessCount}}</span>
                            </el-tooltip>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-card style="margin: 20px;">
            <el-select v-model="msgType" @change="chartInfo"
                       style="width: 200px;float: right;margin-right: 50px;z-index:2 ">
                <el-option
                        v-for="item in templateOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
            <!--      </el-form-item>
                </el-form>-->
            <div id="msgChart" class="chartClass"></div>
        </el-card>
    </div>
</template>

<script>
    import $ from 'jquery'
    import Highcharts from 'highcharts/highstock';
    import HighchartsMore from 'highcharts/highcharts-more';
    import HighchartsDrilldown from 'highcharts/modules/drilldown';
    import Highcharts3D from 'highcharts/highcharts-3d';
    import Highmaps from 'highcharts/modules/map';
    import * as echarts from 'echarts';
    import httpUrl from "@/static/configUrl";
    import {Message} from 'element-ui';

    HighchartsMore(Highcharts)
    HighchartsDrilldown(Highcharts);
    Highcharts3D(Highcharts);
    Highmaps(Highcharts);

    export default {
        name: 'chart',
        components: {
            Message
        },
        data() {

            return {
                // clientId:this.$store.state.request.appId,
                msgType: '',
                totalList: [],
                failList: [],
                title: '',
                qwCount: 0,
                sucQwCount: 0,
                smsCount: 0,
                sucSmsCount: 0,
                mailCount: 0,
                sucMailCount: 0,
                businessCount: 0,
                readBusinessCount: 0,
                templateOptions: [
                    {
                        "label": "全部",
                        "value": ''
                    },
                    {
                        "label": "企微",
                        "value": 1
                    }, {
                        "label": "短信",
                        "value": 2
                    }, {
                        "label": "邮件",
                        "value": 3
                    }, {
                        "label": "业务消息",
                        "value": 4
                    }
                ],
            }
        },
        computed: {
            clientId(){
                return this.$store.state.request.appId
            }
        },
        watch:{
            clientId() {
                this.totalInfo();
                this.chartInfo();
            }
        },
        created() {

        },
        mounted() {
            if(!this.clientId)return
            this.totalInfo();
            this.chartInfo();
        },
        methods: {
            totalInfo() {
                const that = this
                this.$store.dispatch('httpGet', {
                    curl: httpUrl.messageUrl + "/chart/totalInfo",
                    clientId: that.clientId
                }).then(function (res) {
                        const data = res.data
                        that.qwCount = data.qwCount
                        that.sucQwCount = data.sucQwCount
                        that.smsCount = data.smsCount
                        that.sucSmsCount = data.sucSmsCount
                        that.mailCount = data.mailCount
                        that.sucMailCount = data.sucMailCount
                        that.businessCount = data.businessCount
                        that.readBusinessCount = data.readBusinessCount
                })
            },
            chartInfo() {
                const that = this
                that.$store.dispatch('httpGet', {
                    "curl": httpUrl.messageUrl + "/chart/msgChart",
                    "clientId": that.clientId,
                    "msgType": that.msgType
                }).then(function (res) {
                        const data = res.data;
                        that.msgChartInfo(data)
                })
            },
            msgChartInfo(data) {
                const dateList = data.dateList
                this.totalList = data.totalList
                this.failList = data.failList
                switch (this.msgType) {
                    case 1:
                        this.title = '近24小时企微消息发送详情'
                        break;
                    case 2:
                        this.title = '近24小时短信发送详情'
                        break;
                    case 3:
                        this.title = '近24小时邮件发送详情'
                        break;
                    case 4:
                        this.title = '近24小时业务消息发送详情'
                        break;
                    default:
                        this.title = '近24小时消息发送详情'
                        break;
                }
                var msgChart = echarts.init(document.getElementById('msgChart'));
                var option = {
                    grid: {
                        x: 50,
                        y: 50,
                        x2: 50,
                        y2: 60,
                        borderWidth: 10
                    },
                    title: {
                        text: this.title,
                        left: "left",
                        textStyle: {
                            fontSize: 15,
                            fontWeight: "bold"
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        }
                    },
                    legend: {
                        data: [this.msgType === 4 ? '未读消息' : '发送失败', '发送数量']
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: dateList,
                            axisPointer: {
                                type: 'shadow'
                            },
                            axisLabel: {
                                rotate: 45
                            }
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            min: 0,
                        }
                    ],
                    series: [
                        {
                            name: this.msgType === 4 ? '未读消息' : '发送失败',
                            type: 'bar',
                            data: this.failList,
                            barWidth: 20,
                            itemStyle: {
                                color: "rgba(116,125,140)"
                            }
                        },
                        {
                            name: '发送数量',
                            type: 'line',
                            symbol: "none",
                            smooth: true,
                            itemStyle: {
                                color: "rgba(52,152,219)"
                            },
                            data: this.totalList
                        }
                    ]
                };
                msgChart.setOption(option)
            },
        }
    }
</script>
<style lang="scss">

    .chart {
        /*background: #fff;*/

        .chartClass {
            width: 100%;
            height: 500px;
        }
    }

</style>
